// extracted by mini-css-extract-plugin
export default {"container":"styles_container__wMfbb","wrapper":"styles_wrapper__pR0pF"};